import { deleteUserApiV1 } from "@/api/__generated__/api.schema";
import { env } from "@/constants/env";
import { routes } from "@/constants/url";
import { type User, createClient } from "@supabase/supabase-js";
import { Temporal } from "temporal-polyfill";

export const supabase = createClient(env.SUPABASE_URL, env.SUPABASE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  },
});

export async function getAuthSession() {
  return supabase.auth.getSession().then((res) => res.data.session);
}

export async function resetPassword(enteredEmail?: string) {
  const { data, error } = await supabase.auth.getSession();

  if (error != null) {
    throw error;
  }

  const userEmail = data.session?.user.email;

  const email = enteredEmail ?? userEmail;

  if (email == null) {
    throw new Error("No email found");
  }

  if (email) {
    await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${location.origin}/auth/reset-password`,
    });
  }
}

export async function deleteAccount() {
  const { data, error } = await supabase.auth.getSession();

  if (error != null) {
    throw error;
  }

  const userEmail = data.session?.user.email;

  if (userEmail == null) {
    throw new Error("No email found");
  }

  await deleteUserApiV1();
  await supabase.auth.signOut();
}

// NOTE: Supabase doesn't provide which the user signed up, so we need to check it by diff seconds (heuristic way..)
export function checkIsNewUser(user: User) {
  const createdAt = Temporal.Instant.from(user.created_at);
  const lastSignInAt = Temporal.Instant.from(user.last_sign_in_at ?? user.created_at);
  const diffSeconds = Math.abs(createdAt.until(lastSignInAt, { largestUnit: "seconds" }).seconds);
  return diffSeconds <= 5;
}

export async function signout() {
  await supabase.auth.signOut();
  window.location.href = routes.AUTH.signin;
}
